import { PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from "../../../core/_infrastructure/types/common";


export class NombreCientificoItemResultsViewModel extends PagingResultsViewModel {

    public ResultList: NombreCientificoViewModel [];
}

export class NombreCientificoViewModel {

    constructor()
    {
        
    }
    
    public Id: number;
    public Descripcion: string = '';
    public IdCodigoEppo: number | null = null;
    public CodigoEppo: string;
    public Favorito: boolean;
}

export class FilterSearchingNombreCientificoViewModel extends FilterSearchingBaseViewModel{
       
    public Descripcion: string = '';
    public CodigoEppo: string = '';
    public Favorito: number = EnumSiNoTodos.TODOS;
    public SinAsignarEppo: number = EnumSiNoTodos.TODOS;
}







